import { ReadjustmentCompany } from '@app/entities/models/ptrab/shared/company.model';

export class Readjustment {
  isAllowed!: boolean;
  companies!: ReadjustmentCompany[];
}
